<template>
  <div class="b-full-table__row">
    <a :href="editContractUrl"
      class="b-full-table__cell b-full-table__cell-name"
      :class="{'b-full-table__row_bb_true' : show, 'b-full-table__cell--gray': isProject()}"
    >
      {{ currentContract.contract.number }}
    </a>
    <a :href="editContractUrl"
       class="b-full-table__cell b-full-table__cell-name"
       :class="{'b-full-table__row_bb_true' : show, 'b-full-table__cell--gray': isProject()}"
    >
      {{ currentContract.contract.externalId }}
    </a>
    <div
      class="b-full-table__cell"
      :class="{'b-full-table__row_bb_true' : show, 'b-full-table__cell--gray': isProject()}"
    >
      {{ this.getContractStatus() }}
    </div>
    <div
      class="b-full-table__cell"
      :class="{'b-full-table__row_bb_true' : show, 'b-full-table__cell--gray': isProject()}"
    >
      {{ currentContract.contract.date | dateFormatted }}
    </div>
    <div
      class="b-full-table__cell"
      :class="{'b-full-table__row_bb_true' : show, 'b-full-table__cell--gray': isProject()}"
    >
      {{ getLesseeName(currentContract.contract.lesseeCounterpartyId) }}
    </div>
    <div
      class="b-full-table__cell"
      :class="{'b-full-table__row_bb_true' : show, 'b-full-table__cell--gray': isProject()}"
    >
      <div class="mb-2" v-for="item in lessors">{{ item }}</div>
    </div>
    <div
      class="b-full-table__cell b-table__cell_width_md"
      :class="{'b-full-table__row_bb_true' : show, 'b-full-table__cell--gray': isProject()}"
    >
      {{ $t(`CONTENT.events.${currentContract.lastEvent.eventType}`) }}
    </div>
    <div
      class="b-full-table__cell"
      :class="{'b-full-table__row_bb_true' : show, 'b-full-table__cell--gray': isProject()}"
    >
      {{ currentContract.lastEvent.eventDate | dateFormatted }}
    </div>
    <div
      class="b-full-table__cell"
      :class="{'b-full-table__row_bb_true' : show, 'b-full-table__cell--gray': isProject()}"
    >
      {{ currentContract.contract.prolongationType }}
    </div>
    <div
      class="b-full-table__cell"
      :class="{'b-full-table__row_bb_true' : show, 'b-full-table__cell--gray': isProject()}"
    >
      {{ currentContract.contract.responsible }}
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    currentContract: {
      type: Object,
    },
    lessorCache: {
      type: Array
    }
  },
  data() {
    return {
      show: false
    };
  },
  computed: {
    ...mapGetters(['allCounterparties']),
    editContractUrl() {
      return this.$router.resolve({
        name: 'AssetsEdit',
        params: { id: this.currentContract.contract.idInDB }
      }).href;
    },
    lessors() {
      let cache = this.getLessorCache;
      return _.map(this.currentContract.contract.lessorCounterpartyIds, x => this.lessorCache[x].displayName);
    },
    getLessorCache() {
      if (!this.lessorCache) {
        this.lessorCache = _.reduce(this.allCounterparties, (result, x) => { result[x.idInDB] = x; return result}, []);
      }
      return this.lessorCache;
    }
  },
  methods: {
    getContractStatus() {
      if (this.currentContract.contract.status === 5) return `${this.$t('CONTENT.contract_status.status_active')}`;
      if (this.currentContract.contract.status === 4) return `${this.$t('CONTENT.contract_status.status_on_approval_modified')}`;
      if (this.currentContract.contract.status === 3) return `${this.$t('CONTENT.contract_status.status_modified')}`;
      if (this.currentContract.contract.status === 2) return `${this.$t('CONTENT.contract_status.status_on_approval_create')}`;
      if (this.currentContract.contract.status === 1) return `${this.$t('CONTENT.contract_status.status_project')}`;
      return '';
    },
    isProject() {
      return this.currentContract.contract.status === 1;
    },
    getLesseeName(lesseeId) {
      return this.getLessorCache[lesseeId].displayName;
    }
  }
};
</script>
